import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31.43 27.5",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".cls-1{fill:#474c55;}" }) }), /* @__PURE__ */ _jsx("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Layer_1-2",
			"data-name": "Layer 1",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M24.54,15.7H18.66a1,1,0,0,0-1,1v5.88a1,1,0,0,0,1,1h5.88a1,1,0,0,0,1-1V16.7A1,1,0,0,0,24.54,15.7Zm-1,5.88H19.66V17.7h3.88Z"
			}), /* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M30.43,25.5h-1V12.32l.37.28A1,1,0,0,0,31,11L27.5,8.41V1a1,1,0,0,0-1-1H20.62a1,1,0,0,0-1,1V2.62L17.47,1A3,3,0,0,0,14,1L.41,11A1,1,0,0,0,1,12.79a1,1,0,0,0,.59-.19L2,12.33V25.5H1a1,1,0,0,0,0,2H30.43a1,1,0,0,0,0-2ZM21.62,2H25.5V6.94L21.62,4.09ZM13.73,25.5H9.85V18.66a.95.95,0,0,1,1-1h2a.95.95,0,0,1,1,1Zm2,0V18.66a3,3,0,0,0-.22-1.14,3.1,3.1,0,0,0-.64-1,3,3,0,0,0-1-.64,2.92,2.92,0,0,0-1.13-.22h-2a2.92,2.92,0,0,0-1.13.22,3,3,0,0,0-1,.64,3.1,3.1,0,0,0-.64,1,3,3,0,0,0-.22,1.14V25.5H4V10.86l11.19-8.2a1,1,0,0,1,1.14,0l11.18,8.2V25.5Z"
			})]
		})
	})]
});
export default SvgNewHome;
